const getFixedWithLocale = (float, fixed = 2) => float.toFixed(fixed).replace(/[.]/, ",")

export default getFixedWithLocale